import * as z from "zod";

export const connectRichpanelPrivateApp = {
  name: "connectRichpanelPrivateApp" as const,
  input: z.object({
    apiKey: z.string(),
    account: z.string().optional(),
    smsPhoneNumber: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    account: z.nullable(z.string()),
    // The merchant pastes these into a Richpanel HTTP Target (Settings →
    // Integrations) so resolution notifies Redo — Richpanel has no API to
    // register the webhook for us.
    callbackUrl: z.string().optional(),
    webhookToken: z.string().optional(),
    error: z.string().optional(),
  }),
};
